module.exports = __webpack_public_path__ + "static/media/toro-horizontal-white.4bdb44f7.svg";